export const GRANT_TYPE_FEDERATED =
    'urn:epoh:params:oauth:grant-type:federated';
